import { faMobileNotch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

import { T } from "@repo/transifex";
import { AllowanceChip } from "~/components";
import { ProductPageHeader } from "~/components/kiosk/products/product-page-header";
import { UserInfo } from "~/components/kiosk/products/user-info";
import { useMultiClickAction } from "~/hooks/use-multi-click-action";
import { useKioskProducts } from "~/stores/kiosk-session/hooks/use-kiosk-products/use-kiosk-products";
import { useKioskSessionLocale } from "~/stores/kiosk-session/hooks/use-kiosk-session";

import { useKioskStore } from "../../__app.kiosk/route";

export const Header = () => {
  const companyLogo = useKioskStore((state) => state.logoUrl);
  const user = useKioskStore((state) => state.user);
  // enableUserAuthentication it is true even if not set
  const enableUserAuthentication = useKioskStore(
    (state) => state.till.config.enableUserAuthentication !== false
  );
  const { allowances, discounts, currency } = useKioskProducts();
  const locale = useKioskSessionLocale();

  const navigate = useNavigate();

  const handleLogoClick = useMultiClickAction({
    clicksRequired: 3,
    timeoutMs: 1000,
    onAction: () => {
      navigate("admin");
    }
  });

  return (
    <ProductPageHeader
      onLogoClick={handleLogoClick}
      logoUrl={companyLogo ?? undefined}
    >
      {user ? (
        <>
          <AllowanceChip
            allowances={allowances}
            discounts={discounts}
            currency={currency}
            locale={locale}
          />
          <UserInfo userName={user.name} />
        </>
      ) : null}
      {!user && enableUserAuthentication ? <QrCodeBadge /> : null}

      {/* TODO: search bar */}

      {/* TODO: Language selector */}
    </ProductPageHeader>
  );
};

const QrCodeBadge = () => {
  return (
    <div className="flex items-center gap-x-3 rounded-full bg-kiosk-accent-secondary p-6 text-kiosk-text-primary">
      <FontAwesomeIcon icon={faMobileNotch} fontSize={20} />
      <p className="text-xl font-semibold">
        <T _str="Scan your app QR code below" />
      </p>
    </div>
  );
};
